import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

export default WrappedComponent =>
    class extends Component {
        static propTypes = {
            input: PropTypes.object,
            meta: PropTypes.object,
            label: PropTypes.string,
            required: PropTypes.bool
        };

        onChange = value => {
            this.props.input.onChange(value);
        }

        render() {
            const { label, required, meta: { invalid, submitFailed }, className } = this.props;
            const showError = invalid && submitFailed;

            return <Form.Item
                label={label}
                colon={false}
                required={required}
                validateStatus={showError ? 'error' : null}
                className={className}>
                <WrappedComponent
                    {...this.props}
                    onChange={this.onChange} />
            </Form.Item>;
        }
    }
